var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Container',{attrs:{"title":"Impersonate"}},[(_vm.loading)?_c('v-progress-circular',{attrs:{"size":100,"width":10,"indeterminate":""}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }